import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  fields: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1),
    },
  },
  alert: {
    marginBottom: theme.spacing(2),
  },
  buttons: {
    marginTop: theme.spacing(4),
  },
  stepperContainer: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      overflowX: 'auto',
      WebkitOverflowScrolling: 'touch',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      '-ms-overflow-style': 'none',
      'scrollbar-width': 'none',
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
    backgroundColor: 'transparent',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2, 0),
      minWidth: '800px',
    },
  },
  step: {
    [theme.breakpoints.down('sm')]: {
      minWidth: '100px',
      flexShrink: 0,
    },
  },
  contentSplitter: {
    marginTop: theme.spacing(1),
  },
  downContainer: {
    padding: theme.spacing(1, 0),
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
}))
